export default __webpack_public_path__ + "static/media/home-freelancer-bg-img-01.e0b2dd61.png";